export default __webpack_public_path__ + "static/media/right-arrow.b337013f.svg";